A question component of an `ApplicationQuestionnaire`.

Either this or `libraryQuestion` must be provided if the `componentTypeCode` is `Question`.
